module.exports = __webpack_public_path__ + "img/21.669807d8.jpg";